import approve from 'approvejs';
import InputTitle from '../elements/InputTitle';
import InputExample from '../elements/InputExample';
import AddRemBtns from '../elements/AddRemBtns';

export default {

  components: {
    InputTitle,
    InputExample,
    AddRemBtns,
  },

  props: {
    value: {
      default() {
        return [];
      },
    },
    source: '', // Default value
    options: Object,
  },

  data() {
    return {
      valueLocal: this.value,
      error: [],
      widgetOptions: {},
      validateMessages: {
        required: 'Заполните поле',
      },
    };
  },

  created() {
    // Init empty value
    if (!this.value.length) {
      this.addInput();
    }
  },

  methods: {

    setValue(value) {
      if (Array.isArray(value)) {
        if (value.length) {
          this.valueLocal = value;
        }
      } else {
        this.valueLocal = [value];
      }
      this.$forceUpdate();
    },

    clearValue() {
      const value = (typeof this.valueBase === 'object'
        ? Object.assign({}, this.valueBase) : this.valueBase);
      this.valueLocal = [value];
    },

    // Add input element
    addInput() {
      if (typeof this.valueBase === 'object') {
        this.valueLocal.push(Object.assign({}, this.valueBase));
      } else {
        this.valueLocal.push(this.valueBase);
      }
      if (typeof this.errorBase === 'object') {
        this.error.push(Object.assign({}, this.errorBase));
      } else {
        this.error.push(this.errorBase);
      }
    },

    // Delete input element
    removeInput() {
      this.valueLocal.pop();
      this.error.pop();
    },

    // Return errors array for all fields
    getError() {
      // Validate if required
      if (this.options.required) {
        this.valueLocal.forEach((el, i) => {
          if (typeof el === 'object') {
            Object.keys(el).forEach((key) => {
              const result = approve.value(el[key], { required: true });
              this.error[i][key] = result.approved ? '' : this.validateMessages.required;
            });
          } else {
            const result = approve.value(el, { required: true });
            this.error[i] = result.approved ? '' : this.validateMessages.required;
          }
        });
      }
      this.updateError();
      return this.error;
    },

    getValue() {
      const vl = this.valueLocal;
      let isEmpty = true;
      vl.forEach((v) => {
        if (v && typeof v === 'object') {
          Object.keys(v).forEach((key) => {
            isEmpty = (isEmpty && v[key] === '');
          });
        } else {
          isEmpty = (isEmpty && v === '');
        }
      });

      if (this.options && this.options.multiple) {
        if (isEmpty) {
          return [];
        }
        return this.valueLocal;
      }

      return this.valueLocal[0];
    },

    // Remove error message for the field
    removeError(i) {
      if (typeof this.errorBase === 'object') {
        this.error[i] = Object.assign({}, this.errorBase);
      } else {
        this.error[i] = this.errorBase;
      }
      this.$forceUpdate();
      // this.updateError();
    },

    // Force to update valueLocal
    updateValue() {
      this.valueLocal.push('');
      this.valueLocal.pop();
    },

    // Force to update error
    updateError() {
      this.error.push(this.errorBase);
      this.error.pop();
    },

  },
};



// WEBPACK FOOTER //
// ./src/components/inputs/widgets/mixins/Common.js